export const buildVersion = { buildVersion: 'build #396', buildDate: '2026-11-03T14:39:06.125+0100' };